import { Drawer, DatePicker, Tooltip, Input, Modal, Form } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { Accordion, ToastContainer } from "react-bootstrap";
import styles from "./index.module.scss";
import moment from "moment";
import Dropdown from "../../DropDown/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import {
  EditIcon,
  EditRpmIcon,
  RpmStatusTriangle,
  ArrowLeft,
} from "../../../assets/Logos/Icons";
import CustomPhoneInputV2 from "../../CustomPhoneInputV2/CustomPhoneInputV2";
import {
  fetchdoctors,
  fetchpatients,
  resetPassword, 
  updateStatus,
  getPatientDetails,
  searchbyname,
  updateprofileinformation,
  downloadAppointmentPatientReport,
  fetchmypatients,
} from "../../../actions/UserAction";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "../../TodaysReport/todaysreport.css";
import { Pagination } from "antd";
import { toast } from "react-toastify";
import { SearchOutlined } from "@ant-design/icons";
import EmptyTableData from "../../Common/EmptyTableData/EmptyTableData";
import { message } from "antd";
import UserFilters from "../../UserFilters/UserFilters";
import Spinner from "react-bootstrap/Spinner";
import { debounce } from "lodash";

const { Search } = Input;

function Patient({ isDoctor }) {
  let [_isDoctor, setIsDoctor] = useState(isDoctor || true);
  let [isDrawerOpen, setDrawerOpen] = useState(false);
  let dispatch = useDispatch();
  const [doctorList, setDoctorList] = useState([]);
  const [patientList, setPatientList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedList, setSelectedList] = useState([]);
  const [callRefresh, setCallRefresh] = useState(false);
  const [searchType, setSearchTypeh] = useState("All");
  const [seachbyname, setseachbyname] = useState("");
  let [selectedDate, setSelectedDate] = useState({ from: null, to: null });
  const [searchText, setSearchText] = useState("");
  let [loader, setLoader] = useState(true);
  let [isInitial, setinitial] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [SearchResult, setSearchResult] = useState(false);
  const getUserType = () => (_isDoctor ? "doctor" : "patient");
  const formRef = useRef(null);
  const [filterParams, setFilterParams] = useState(null);
  const [patientName, setPatientName] = useState(null);
  const [patientNumber, setpatientNumber] = useState(null);
  const [patientEmail, setPatientEmail] = useState(null);
  const [resetfilter, setresetfilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const userType = getUserType();
  const gettingList =
    userType === "doctor" ? doctorList.doctorList : patientList.patientList;
  console.log("gettingList", gettingList);

  let userDetails = JSON.parse(localStorage.getItem("userData"))

  const handleFilterAndSearch = (filterData) => {
    const { filterParams, searchType } = filterData;
    if (!filterParams) {
      setPatientName(null);
      setSearchTypeh("All");
      setseachbyname("");
      setCurrentPage(1);
      setSearchResult(false);
      return;
    }

    if (filterParams && filterParams.name === "BY_PATIENT") {
      setPatientName(filterParams.value);
      setSearchTypeh(searchType || "byName");
      setseachbyname(filterParams.value);
      dispatch(fetchmypatients(0, searchType || "byName", filterParams.value,userDetails.userId))
        .then((res) => {
          console.log("API Response:", res);
          setPatientList(res);
          setTotalPages(res.totalPages);
          setSearchResult(res.length > 0);
        })
        .catch((err) => {
          console.error("API Error:", err);
        });
    } else if (filterParams && filterParams.name === "BY_NUMBER") {
      setpatientNumber(filterParams.value); // Set the number only
      setSearchTypeh(searchType || "byNumber");
      // setseachbyname(filterParams.value?.number); // Pass the number only
      setPatientName(null);
      dispatch(fetchmypatients(0, "byNumber", filterParams.value,userDetails.userId))
        .then((res) => {
          console.log("API Response:", res);
          setPatientList(res);
          setTotalPages(res.totalPages);
          setSearchResult(res.length > 0);
        })
        .catch((err) => {
          console.error("API Error:", err);
        });
    } else if (filterParams && filterParams.name === "BY_EMAIL") {
      // Handle BY_EMAIL case here
      setPatientEmail(filterParams.value); // Set the number only
      setSearchTypeh(searchType || "byEmail");
      // setseachbyname(filterParams.value?.number); // Pass the number only
      setPatientName(null);
      setpatientNumber(null);
      dispatch(fetchmypatients(0, "byEmail", filterParams.value,userDetails.userId))
        .then((res) => {
          console.log("API Response:", res);
          setPatientList(res);
          setTotalPages(res.totalPages);
          setSearchResult(res.length > 0);
        })
        .catch((err) => {
          console.error("API Error:", err);
        });
    }
  };
  console.log("mobileNumber", patientNumber);
  console.log("patientEmail", patientEmail);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const currentSearchValue =
          patientName || patientNumber || patientEmail || seachbyname;
        const res = await dispatch(
          fetchmypatients(currentPage - 1, searchType, currentSearchValue,userDetails.userId)
        );
        console.log(res);
        setPatientList(res);
        setTotalPages(res.totalPages);
        //setLoader(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoader(false);
      }
    };

    fetchData();
  }, [currentPage, searchType, seachbyname, dispatch]);

  useEffect(() => {
    setIsDoctor(isDoctor);
  }, [isDoctor]);

  //Table data modal start............................................................
  let headers = {
    patient: [
      { name: "Patient ID", key: "patient_id" },
      { name: "Full Name", key: "patient_name" },
      { name: "Mobile Number", key: "mobileNumber" },
      { name: "Email ID", key: "email" },
      //   { name: "URN Number", key: "MrnId" },
      { name: "Joined on", key: "last_login" },
      { name: "Last LoggedIn", key: "LastLoggedIn" },
    ],
  };
  let tableData = {
    doctor: doctorList,
    patient: patientList,
  };

  console.log("list..", doctorList.doctorList);
  //Table data modal end............................................................

  let handleCloseDrawer = () => {
    const currentSearchType = searchType;
    const currentSearchValue = patientName || patientNumber || patientEmail || seachbyname;

    // setCurrentPage(1);
  
    dispatch(fetchmypatients(currentPage - 1, currentSearchType, currentSearchValue,userDetails.userId))
      .then((res) => {
        console.log("API Response:", res);
        setPatientList(res);
        setTotalPages(res.totalPages);
      })
      .catch((err) => {
        console.error("API Error:", err);
      })
      .finally(() => {
        setDrawerOpen(false);
        setSelectedUser(null);
      });
  };

  let handleClickMore = (id) => {
    setDrawerOpen(true);
    setSelectedUser(id);
    console.log("user..", id);
  };

  const handleResetPassword = async () => {
    await dispatch(resetPassword("32533168", "password"))
      .then((res) => {
        console.log("API response:", res);
        setSelectedUser(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleToggleStatus = async (userId, currentStatus) => {
    try {
      // Updating the local state with the new status immediately
      const updatedStatus = currentStatus === "Active" ? "Inactive" : "Active";
      const updatedList = doctorList.doctorList.map((eachRow) => {
        if (eachRow.userId === userId) {
          return {
            ...eachRow,
            status: updatedStatus,
          };
        }
        return eachRow;
      });
      setDoctorList({ ...doctorList, doctorList: updatedList });

      // API call to update the status
      await dispatch(updateStatus(userId, updatedStatus));

      toast.success("Status updated successfully!");
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Status update failed!");
    }
  };


 // Update the handlePageChange function
const handlePageChange = (page) => {
  setCurrentPage(page);
  dispatch(fetchpatients(page - 1, searchType, seachbyname,userDetails.userId))
    .then((res) => {
      console.log("API Response:", res);
      setPatientList(res);
      setTotalPages(res.totalPages);
    })
    .catch((err) => {
      console.error("API Error:", err);
    });
};

  const handlenameChange = (page, value) => {
    console.log("handlenameChange function called.");
    console.log("Search Text: ", page);
    setSearchValue(value);
    setseachbyname(page);
    if (page != "" && page.length > 0) {
      setSearchTypeh("byName");
      dispatch(fetchmypatients(0, "byName", page))
        .then((res) => {
          console.log("API Response:", res);
          setPatientList(res);
          setTotalPages(res.totalPages);
          setSearchResult(res.length > 0);
        })
        .catch((err) => {
          console.error("API Error:", err);
        });
    } else {
      setSearchTypeh("All");
      setseachbyname("");
      setCurrentPage(1);
      setSearchResult(false);
    }
  };

  const handleClearClick = () => {
    setSearchValue("");
  };

  const onSearch = (value) => {
    console.log("onserch", value.length);
    if (value.length === 0) {
      console.log("onserfdsfch", value.length);
      setSearchTypeh("All");
      setCurrentPage(1);
    }
  };

  console.log("setSearchTypeh ,setCurrentPage", searchType, currentPage);

  const resetFilterAction = () => {
    // Reset the necessary state variables
    setPatientName(null);
    setSearchTypeh("All");
    setseachbyname("");
    setCurrentPage(1);
    setSearchResult(false);
    setresetfilter(true);
    setLoader(true);

    const fetchData = async () => {
      try {
        // Call the API to fetch the initial data
        const res = await dispatch(fetchmypatients(0, "All", "",userDetails.userId));
        console.log(res);
        setPatientList(res);
        setTotalPages(res.totalPages);
        setLoader(false);
        //setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoader(false);
         //setIsLoading(false);
      }
    };
    fetchData();
  };

  let downloadReport = () => {
    console.log("Downloading report.........");
    setIsLoading(true);
    dispatch(
      downloadAppointmentPatientReport({
        SearchType: searchType,
        patientName: patientName,
        patientNumber: patientNumber,
        patientEmail: patientEmail,
      })
    ).then((res) => {
      console.log("Response:", res);
      console.log("name", seachbyname);

      if (res) {
        console.log("Download URL:", res);
        window.open(res, "_blank");
        toast.success("Downloaded Successfully!");
      }
      setIsLoading(false);
    });
  };

  const handleKeyDown = (e) => {
    if (
      !(
        (e.keyCode >= 65 && e.keyCode <= 90) ||
        (e.keyCode >= 97 && e.keyCode <= 122) ||
        e.keyCode === 32 ||
        e.keyCode === 8
      )
    ) {
      e.preventDefault();
    }
  };

  return (
    <div className={styles.usersTableWrap}>
      <div className={styles.usersTableContainer}>
        <div style={{ display: "flex", width: "100%", flexWrap: "wrap", gap: "12px" }}>
          <div
            className={styles.header}
            style={{
              width: "100%",
               display: "none",
              // justifyContent: "flex-start",
              marginTop: "32px",
            }}
          >
            {gettingList && gettingList?.length > 0 && (
              <button
                onClick={() => {
                  downloadReport();
                }}
                className={styles.downloadbtn}
                // disabled={isLoading}
              >
                <>
                  <div className="icon">
                    {isLoading ? (
                      <Spinner
                        style={{
                          width: "20px",
                          height: "20px",
                          color: "black",
                        }}
                        animation="border"
                        role="status"
                      ></Spinner>
                    ) : (
                      <i className="far fa-download"></i>
                    )}
                  </div>{" "}
                  <div>Download Report</div>
                </>
              </button>
            )}
          </div>
          {/* {loader === false && (
            <div className={styles.searchContainer}>
              <Input
                placeholder="Search Patient By Name"
                allowClear
                className={styles.searchBox}
                suffix={<SearchOutlined />}
                size="medium"
                onKeyUp={(e) => handlenameChange(e.target.value)}
                onKeyDown={handleKeyDown}
                value={searchValue}
                onChange={(e) => handlenameChange(e.target.value)}
              />
            </div>
          )} */}
          <div style={{ flex: "1 1 360px", minWidth: 280, maxWidth: "100%" }}>
            <UserFilters
              //  onDownloadRequest={handleDownloadRequest}
              onFilterSubmit={(params) => {
                console.log("🚀 ~ TodaysReport ~ params:", params);
                handleFilterAndSearch(params);
              }}
              resetFilterAction={resetFilterAction}
            />
          </div>
        </div>
        {userType === "patient" && (
          <div className={styles.tableWrapper}>
            <table>
              <thead>
                <tr>
                  {headers[getUserType()]?.map((eachHeader, key) => {
                    return <th key={key}>{eachHeader?.name}</th>;
                  })}
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {gettingList?.length > 0 ? (
                  gettingList.map((obj, index) => (
                    <tr key={index}>
                      <td>{obj.PatientId || "NA"}</td>
                      {/* <td>{obj.FullName || "NA"}</td> */}
                      <td>{obj.FullName ? obj.FullName.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "NA"}</td>
                      <td>{obj.MobileNumber || "NA"}</td>
                      <td>{obj.Email && obj.Email !== "Null" ? obj.Email : "NA"}</td>
                      {/* <td>{obj.MrnId || "NA"}</td> */}
                      <td>{obj.Createdat || "NA"}</td>
                      <td>{obj.LastLoggedIn || "NA"}</td>
                      <td>
                        <button
                          className={styles.more_btn}
                          onClick={() => {
                            handleClickMore(obj.PatientId);
                          }}
                        >
                          More
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7}>
                      <EmptyTableData
                        isLoading={loader}
                        haveButton={false}
                        text={"No results found"}
                        caption={""}
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className={styles.usersTableFooter}>
        <div className={styles.pagination}>
          <Pagination
            showSizeChanger={false}
            current={currentPage}
            pageSize={1}
            total={totalPages}
            onChange={handlePageChange}
            hideOnSinglePage={true}
          />
        </div>
      </div>

      <Drawer
        width={"500px"}
        headerStyle={{ display: "none" }}
        title={null}
        placement="right"
        onClose={handleCloseDrawer}
        open={isDrawerOpen}
        // closeIcon={false}
        className={styles.detailsModal}
      >
        <div className={styles.more_content_wrap}>
          {/* <div className={styles.closeBtn} onClick={handleCloseDrawer}>x</div> */}

          <DetailedView isDoctor={_isDoctor} selectedUser={selectedUser} />
          {console.log("user...", selectedUser)}
        </div>
      </Drawer>
    </div>
  );
}
export default Patient;

const DetailedView = ({ isDoctor, selectedUser, formRef }) => {
  const [user, setUser] = useState(selectedUser);
  const [patientDetails, setPatientDetails] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  let [isedit, setisedit] = useState(false);
  let [IsUpdated, setIsUpdated] = useState(false);
  let [accessCountry, setAccessCountry] = useState("IN");
  let dispatch = useDispatch();
  const { confirm } = Modal;
  const [mainNumber, setMainNumber] = useState(true);
  console.log("mainNumber", mainNumber);

  let [formData, setFormData] = useState({
    patientName: "",
    gender: "",
    dateofbirth: "",
    emailid: "",
    bloodgroup: "",
    maritalstatus: "",
    occupation: "",
    dob: "",
    mobilenumber: "",
    alternativephoneNumber: "",
    address1: "",
    address2: "",
  });
  const genderOptions = [
    { value: "Male", option: "Male" },
    { value: "Female", option: "Female" },
    { value: "Other", option: "Other" }
  ];

  const Marriagestatus = [
    "Single",
    "Married",
    "Divorced",
    "Separated",
    "Widowed",
  ];
  const { TextArea } = Input;
  const bloodGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];

  useEffect(() => {
    dispatch(getPatientDetails(selectedUser)).then((res) => {
      console.log(res);
      setPatientDetails(res);
      setFormData({
        patientId: selectedUser,
        patientName: res.patientName || "",
        Information: { patientName: res.patientName || "" },
        gender: res.gender || "",
        dateofbirth: res.dob || "",
        emailId: res.emailId || "",
        //bloodgroup:res.bloodgroup||"",
        bloodgroup:
          res.bloodgroup != null
            ? res.bloodgroup.includes("+")
              ? res.bloodgroup?.replace("+", "%2B")
              : res.bloodgroup?.replace("-", "%2D")
            : "",

        maritalstatus: res.maritalstatus,
        occupation: res.occupation || "",
        dob: res.dob || "",
        mobilenumber: res.mobileNumber?.replace("+", "%2B") || "",
        alternativephoneNumber:
          mainNumber === true
            ? ""
            : res.alternativephoneNumber?.replace("+", "%2B") || "",
        address1: res.address1 || "",
        address2: res.address2 || "",
        urn: res.mrn || "",
        emriatesId: res.emirateId || "",
      });
      SetcountryCode(res.alternativephoneNumber?.split(" ")[0]);
      setAlternateNumber(res.alternativephoneNumber?.split(" ")[1]);
    });
  }, [selectedUser, IsUpdated]);

  console.log("selectedUser", selectedUser);
  console.log("IsUpdated", IsUpdated);
  
  const handleResetPassword = () => {
    setIsModalOpen(true);
  };
  let allowOnlyunumber = (e) => {
    if (e.target.value.includes(".") && e.key == ".") {
      e.preventDefault();
    }

    ![
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ".",
      "Backspace",
    ].includes(e.key) && e.preventDefault();
  };
  const confirmResetPassword = async () => {
    await dispatch(resetPassword(selectedUser, "password"))
      .then((res) => {
        console.log("API response:", res);
        //setSelectedUser(res);
        toast.success("Password updated successfully");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  let Mandatory = () => <span className={styles.mandatory}>*</span>;
  const [alternateNumber, setAlternateNumber] = useState(
    formData?.alternativephoneNumber
      ? formData.alternativephoneNumber.split(" ")[1]

      : ""
  );
  console.log("alternate", alternateNumber);

  const [countryCode, SetcountryCode] = useState("");
  console.log("alternate2", countryCode);

  let patientHeader = [
    {
      name: "Patient Details",
      options: [
        { name: "Full Name", key: "patientName" },
        { name: "Email ID", key: "emailId" },
        { name: "Gender", key: "gender" },
        // { name: "Emirates ID", key: "emirateId" },
        { name: "Mobile Number", key: "mobileNumber" },
        { name: "Alternate Number", key: "alternativephoneNumber" },
        // { name: "URN Number", key: "mrn" },
        { name: "Date Of Birth", key: "dob" },
        // { name: "Blood Group", key: "bloodgroup" },
        // { name: "Occupation", key: "occupation" },
        { name: "Address", key: "address1" },
        // { name: "Address 2", key: "address2" },
        // { name: "Timezone", key: "" },
      ],
    },
  ];

  let getHeaders = () => patientHeader;

  if (!selectedUser) {
    return null;
  }

  const handleToggleStatus = () => {
    const updatedStatus = user?.status === "Active" ? "Inactive" : "Active";

    // Update the status in the user object
    setUser({ ...user, status: updatedStatus });

    console.log("Toggle status", updatedStatus);
  };

  const editdetails = () => {
    console.log("editdetails");
    setisedit(true);
    if (patientDetails?.alternativephoneNumber) {
      setMainNumber(false);
    }
  };

  let handleEditInputChanges = ({ key, value }) => {
    console.log("kk", { key, value });
    setFormData({ ...formData, [key]: value });
    console.log("Form", formData.alternativephoneNumber);
  };

  const handleKeyDown = (e) => {
    if (
      !(
        (e.keyCode >= 65 && e.keyCode <= 90) ||
        (e.keyCode >= 97 && e.keyCode <= 122) ||
        e.keyCode === 32 ||
        e.keyCode === 8
      )
    ) {
      e.preventDefault();
    }
  };
  const showConfirm = () => {
    confirm({
      title: "Do you want to reset the password?",
      centered: true,
      // icon: <ExclamationCircleFilled />,
      //content: 'Some descriptions',
      okText: "Yes",
      cancelText: "No",
      onOk() {
        console.log("OK");
        confirmResetPassword();
      },
      onCancel() {
        console.log("Cancel");
      },
      okButtonProps: {
        style: {
          backgroundColor: "#0c8de0",
          color: "white",
          borderRadius: "10px",
          height: "50px",
          width: "110px",
          alignItems: "center",
          border: "1px solid #0c8de0",
          marginLeft: "10px",
          fontWeight: 500,
          flexDirection: "row",
          justifyContent: "flex-end",
        },
      },
      cancelButtonProps: {
        style: {
          borderRadius: "10px",
          height: "50px",
          width: "110px",
          alignItems: "center",
          border: "1px solid #0c8de0",
          marginLeft: "10px",
          fontWeight: 500,
          flexDirection: "row",
          justifyContent: "flex-end",
          color: "#0c8de0",
        },
      },
    });
  };

  const status = selectedUser[0]?.status;

  let handleEditOk = () => {
    const updatedPatientData = {
      ...formData,
      mobilenumber: formData.mobilenumber.replace("+", "+%2B"),
      alternativephoneNumber:
        mainNumber === true ? "" : `%2B${countryCode} ${alternateNumber}`,
      bloodgroup:
        formData.bloodgroup != null
          ? formData.bloodgroup.includes("+")
            ? formData.bloodgroup.replace("+", "%2B")
            : formData.bloodgroup.replace("-", "%2D")
          : "",
    };
    console.log("formData", updatedPatientData);
    if (
      formData?.mobilenumber?.split(" ")[1] !==
      formData?.alternativephoneNumber?.split(" ")[1]
    ) {
      dispatch(updateprofileinformation(updatedPatientData))
        .then((res) => {
          console.log("formdata", res);
          if (res.info === "Patient profile updated successfully") {
            getPatientDetails();
            fetchpatients(0, "All", "")
            setIsUpdated(true);
            toast.success("Patient profile updated successfully");
            setisedit(false);
            setFormData(formData);
            formRef?.current?.resetFields();
          } else {
            toast.success("Something went wrong!");
          }
        })
        .catch((error) => {
          console.error("Error updating profile:", error);
        });
    }
  };

  let onFinishFailedVitals = () => {};

  let handleEditClose = () => {
    console.log("hiih");
    setFormData(formData);
    formRef?.current?.resetFields();
    //setEditOpen(false)
    setisedit(false);
    setMainNumber(true);
    //profileform.resetFields();
  };
  //handleResetPassword
  console.log("formData", formData);
  {
    console.log("sign2", formData?.mobilenumber?.split(" ")[1]);
  }
  {
    console.log("sign", formData?.alternativephoneNumber);
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  return (
    <>
      <div className={styles.detail_view_action_btn_wrap}>
        <button onClick={showConfirm}> Reset Password</button>
        {isDoctor && (
          <button onClick={handleToggleStatus}>
            {status === "Active" ? "Make Offline" : "Make Online"}
          </button>
        )}
      </div>

      {getHeaders().map((eachSection, sectionKey) => {
        return (
          <div key={sectionKey} className={styles.detailedSection}>
            <div className={styles.detailedSectionHeader}>
              <div> {eachSection?.name}</div>
              <div>
                {" "}
                <span onClick={editdetails}>
                  {" "}
                  <EditRpmIcon />{" "}
                </span>
              </div>
            </div>

            {/* {eachSection.options.map((obj, optionKey) => {
              const value = patientDetails;
              console.log("values...", value);
              console.log("data...", obj.key);
              console.log("obj..", obj);
              return (
                <div key={optionKey} className={styles.sectionItem}>
                  <div className={styles.sectionItemKey}>{obj.name}</div>
                  <div>:</div>
                  <div
                    className={styles.sectionItemValue}
                    style={{ marginLeft: "15px" }}
                  >
                    {obj.key === "dob" ? (
                      // Checking if the key is "dob" to display both DOB and Age
                      <>
                        {value[obj.key] !== undefined ? (
                          // Display DOB if it exists
                          <>
                            {value[obj.key]}{" "}
                            {value.age && (
                              <span>({value.age + " " + "years"})</span>
                            )}
                          </>
                        ) : (
                          // Display "NA" if DOB is not present
                          "NA"
                        )}
                      </>
                    ) : (
                      // Display the value if the key is not "dob"
                      value[obj.key] || "NA"
                    )}
                  </div>
                </div>
              );
            })} */}
            <table className={styles.todays_report_table}>
              <tbody>
                <tr>
                  <td className="cell1 odd">Full Name</td>
                  <td className="cell3 odd">
                    {/* {patientDetails?.patientName || "NA"} */}

                    {patientDetails.patientName ? patientDetails.patientName.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "NA"}

                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Email</td>
                  <td className="cell3 odd">
                    {patientDetails?.emailId || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Mobile Number</td>
                  <td className="cell3 odd">
                    {patientDetails?.mobileNumber || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Alternate Number</td>
                  <td className="cell3 odd">
                    {patientDetails?.alternativephoneNumber || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Gender</td>
                  <td className="cell3 odd">
                    {patientDetails?.gender || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Date Of Birth</td>
                  <td className="cell3 odd">
                    {patientDetails?.dob ? (
                      <>
                        {patientDetails.dob}{" "}
                        {patientDetails.age !== undefined && (
                          <span>({patientDetails.age + " " + "years"})</span>
                        )}
                      </>
                    ) : (
                      "NA"
                    )}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Address</td>
                  <td className="cell3 odd">
                    {patientDetails?.address1 || "NA"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      })}
      <ConfirmationModal
        isOpen={isModalOpen}
        onConfirm={confirmResetPassword}
        onClose={closeModal}
      />

      <Modal
        title="Patient Details"
        width={920}
        closable={false}
        footer={null}
        maskClosable={false}
        open={isedit}
        //onOk={handleEditOk}
        //onCancel={handleEditClose}
      >
        <div className="edit-profile-modal-container rejectpackage">
          <Form
            ref={formRef}
            name="profileform"
            onFinish={handleEditOk}
            onFinishFailed={onFinishFailedVitals}
            autoComplete="off"
            preserve={false}
          >
            <div className="edit-profile-body">
              <div className="edit-profile-form-item">
                <span className="edit-profile-caption">
                  Full Name <label style={{ color: "#ff4d4f" }}>*</label>
                </span>
                <Form.Item
                  name="Informationfullname"
                  rules={[
                    { required: true, message: "Please Enter Full Name" },
                  ]}
                  initialValue={patientDetails?.patientName}
                >
                  <Input
                    id="ProfileName"
                    defaultValue={patientDetails?.patientName}
                    onChange={(e) => {
                      handleEditInputChanges({
                        key: "patientName",
                        value: e.target.value,
                      });
                    }}
                    placeholder="Enter Full Name"
                    onKeyDown={handleKeyDown}
                    onKeyPress={(e) => {
                      const englishRegex = /^[a-zA-Z\s]*$/;
                      if (
                        !englishRegex.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "Delete"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      const pastedData = e.clipboardData.getData("text/plain");
                      const englishRegex = /^[a-zA-Z\s]*$/;
                      if (!englishRegex.test(pastedData)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </div>

              <div className="edit-profile-form-item">
                <span className="edit-profile-caption">
                  Email id <label style={{ color: "#ff4d4f" }}>*</label>
                </span>
                <Form.Item
                  name="InformationemailId"
                  rules={[
                    { required: true, message: "Please Enter Email Id  " },
                    {
                      type: 'email',
                      message: 'Please enter a valid Email ID',
                    },
                    // {
                    //   pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    //   message: 'Please enter a valid Email ID',
                    // },
                  ]}
                  initialValue={patientDetails?.emailId}
                >
                  <Input
                    defaultValue={patientDetails?.emailId}
                    id="Email"
                    onChange={(e) => {
                      handleEditInputChanges({
                        key: "emailId",
                        value: e.target.value,
                      });
                    }}
                    placeholder=" Enter Email Id"
                    disabled={!!patientDetails?.emailId}
                    style={{ cursor: patientDetails?.emailId ? "not-allowed" : "text" }}                  />
                </Form.Item>
              </div>
              <div className="edit-profile-form-item">
                <span className="edit-profile-caption">
                  Mobile Number <label style={{ color: "#ff4d4f" }}>*</label>
                </span>
                {/* <Input id='Mobile'  defaultValue={patientDetails?.mobilenumber} onChange={handleEditInputChange} placeholder="Type here" />
                 */}

                <Form.Item
                  name="Informationmobilenumber"
                  rules={[
                    { required: true, message: " Please Enter Mobile Number" },
                    {
                      min: 6,
                      message: "The mobile number should be minimum 6 digits",
                    },
                  ]}
                  initialValue={patientDetails?.mobileNumber?.split(" ")[1]}
                  style={{ cursor: "not-allowed" }}
                >
                  {/* <CustomPhoneInputV2
                       placeholder="Mobile Number"
                       defaultCountryCode={
                         patientDetails?.mobileNumber?.split(" ")[0]
                       }
                       defaultValue={patientDetails?.mobileNumber?.split(" ")[1]}
                       value={patientDetails?.mobileNumber?.split(" ")[1]}
                       onChange={(number, value, data) => {
                         console.log(number, value, data);
                         handleEditInputChanges({
                           key: "mobilenumber",
                           value: value,
                         });
                       }}
                       disabled
                    /> */}
                  <CustomPhoneInputV2
                    placeholder="Mobile Number"
                    defaultCountryCode={
                      patientDetails?.mobileNumber?.split(" ")[0]
                    }
                    defaultValue={patientDetails?.mobileNumber?.split(" ")[1]}
                    value={patientDetails?.mobileNumber?.split(" ")[1]}
                    onChange={(number, value, data) => {
                      console.log(number, value, data);
                      handleEditInputChanges({
                        key: "mobilenumber",
                        value: `+${value}`,
                      });
                    }}
                    disabled={patientDetails?.mobileNumber?.split(" ")[0] && patientDetails?.mobileNumber?.split(" ")[1] ? true : false}                              
                     />
                </Form.Item>
                <div>
                  <input
                    type="checkbox"
                    name="checkboxId"
                    id="get_touch_check"
                    placeholder=""
                    value={mainNumber}
                    checked={mainNumber}
                    onChange={(e) => setMainNumber(e.target.checked)}
                    style={{ cursor: "pointer" }}
                  />
                  <label for="get_touch_check" style={{ marginLeft: "6px" }}>
                    This is my number on WhatsApp
                  </label>
                </div>
              </div>
              {!mainNumber && (
                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Alternate Number{" "}
                  </span>

                  <Form.Item
                    name="InformationalternativephoneNumber"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Alternative Number",
                      },
                      {
                        min: 6,
                        message:
                          "The mobile number should be a minimum of 6 digits",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const mainMobileNumber = getFieldValue(
                            "Informationmobilenumber"
                          );

                          if (value !== mainMobileNumber) {
                            console.log("value...........", mainMobileNumber);
                            return Promise.resolve();
                          }
                          if (
                            value === mainMobileNumber &&
                            mainMobileNumber !== undefined
                          ) {
                            return Promise.reject(
                              "Please enter a different mobile number"
                            );
                          } else {
                            return Promise.reject();
                          }
                        },
                      }),
                    ]}
                    initialValue={
                      patientDetails?.alternativephoneNumber?.split(" ")[1]
                    }
                  >
                    <CustomPhoneInputV2
                      placeholder="Mobile Number"
                      defaultCountryCode={countryCode}
                      value={mainNumber === true ? "" : alternateNumber}
                      onChange={(number, value, data) => {
                        console.log("data222", number, value, data);
                        // handleEditInputChanges({
                        //   key: "alternativephoneNumber",
                        //   value: value,
                        // });
                        setAlternateNumber(number);
                        SetcountryCode(data?.dialCode);
                      }}
                    />
                  </Form.Item>
                </div>
              )}

              <div className="edit-profile-form-item">
                <span className="edit-profile-caption">
                  Gender <label style={{ color: "#ff4d4f" }}>*</label>
                </span>
                <Form.Item
                  name="gender"
                  rules={[{ required: true, message: "Please Select Gender " }]}
                  initialValue={patientDetails?.gender}
                >
                  <Dropdown
                    value={formData?.gender}
                    id="ProfileGender"
                    data={genderOptions}
                    // onChange={handleEditInputChanges}
                    onChange={(value) => handleEditInputChanges({ key: "gender", value })}
                    style={{color: "#ff4d4f"}}
                    placeholder="Select Gender"
                  />
                </Form.Item>
              </div>

              <div className="edit-profile-form-item">
                <span className="edit-profile-caption">
                  Date of birth <label style={{ color: "#ff4d4f" }}>*</label>
                </span>
                <Form.Item
                  name="dob"
                  rules={[
                    { required: true, message: "Please Select Date Of Birth" },
                  ]}
                  initialValue={
                    formData?.dob ? moment(formData?.dob) : undefined
                  }
                >
                  <DatePicker
                    defaultValue={
                      formData?.dob ? moment(formData?.dob) : undefined
                    }
                    className="input-date"
                    style={{ width: "100% !important" }}
                    maxDate={moment().toDate()}
                    format="DD/MMM/YYYY"
                    placeholder="DD/MM/YYYY"
                    disabledDate={(current) => {
                      return current > moment().subtract(1, "day");
                    }}
                    allowClear={false}
                    onChange={(date_moment, value) => {
                      handleEditInputChanges({ key: "dob", value: value });
                    }}
                  />
                </Form.Item>
              </div>

              {/* <div className="edit-profile-form-item">
                <span className="edit-profile-caption">Blood Group :</span>
                <Form.Item
                  name="bloodgroup"
                  rules={[{ required: true, message: "Select blood group " }]}
                  initialValue={patientDetails?.bloodgroup}
                >
                  <Dropdown
                    //  value={patientDetails?.bloodgroup}
                    id="BloodGroup"
                    data={bloodGroups}
                    onChange={(e) => {
                      handleEditInputChanges({
                        key: "bloodgroup",
                        value: e.value,
                      });
                    }}
                    placeholder="Select Blood Group"
                  />
                </Form.Item>
              </div> */}

              {/* <div className="edit-profile-form-item">
                <span className="edit-profile-caption">Marital Status :</span>
                <Form.Item
                  name="Informationmaritalstatus"
                  rules={[
                    { required: true, message: "Select marital status " },
                  ]}
                  initialValue={patientDetails?.maritalstatus}
                >
                  <Dropdown
                    value={patientDetails?.maritalstatus}
                    id="MaritalStatus"
                    data={Marriagestatus}
                    onChange={(e) => {
                      handleEditInputChanges({
                        key: "maritalstatus",
                        value: e.value,
                      });
                    }}
                    placeholder="Select Marital Status"
                  />
                </Form.Item>
              </div> */}

              {/* <div className="edit-profile-form-item">
                <span className="edit-profile-caption">Emirates ID :</span>
                <Form.Item
                  name="Emiratesid"
                  rules={[{ required: true, message: "Enter Emirates ID  " }]}
                  initialValue={patientDetails?.emirateId}
                >
                  <Input
                    defaultValue={patientDetails?.emirateId}
                    maxLength={30}
                    id="Emiratesid"
                    onChange={(e) => {
                      handleEditInputChanges({
                        key: "emriatesId",
                        value: e.target.value,
                      });
                    }}
                    placeholder="Enter Emirates Id"
                  />
                </Form.Item>
              </div> */}
              {/* <div className="edit-profile-form-item">
                <span className="edit-profile-caption">URN :</span>
                <Form.Item
                  name="URN"
                  rules={[{ required: true, message: "Enter URN  " }]}
                  initialValue={patientDetails?.mrn}
                >
                  <Input
                    defaultValue={patientDetails?.mrn}
                    maxLength={30}
                    id="URN"
                    onChange={(e) => {
                      handleEditInputChanges({
                        key: "urn",
                        value: e.target.value,
                      });
                    }}
                    placeholder="Enter URN"
                  />
                </Form.Item>
              </div> */}
              {/* <div className="edit-profile-form-item">
                <span className="edit-profile-caption">Occupation :</span>
                <Form.Item
                  name="Informationoccupation"
                  rules={[{ required: true, message: "Enter Occupation  " }]}
                  initialValue={patientDetails?.occupation}
                >
                  <Input
                    defaultValue={patientDetails?.occupation}
                    maxLength={30}
                    id="Informationoccupation"
                    onChange={(e) => {
                      handleEditInputChanges({
                        key: "occupation",
                        value: e.target.value,
                      });
                    }}
                    placeholder="Enter Occupation"
                  />
                </Form.Item>
              </div> */}

              {/* <div className="edit-profile-form-item">
                                    <span className="edit-profile-caption">Email id :</span>
                                    <Form.Item
                                    name="Informationoccupation"
                                    rules={[{ required: true, message: 'Please enter Height  ' }]}
                                    initialValue={patientDetails?.occupation}
                                    >
                                        <Input defaultValue={patientDetails?.emailid} id='Email' onChange={handleEditInputChange} placeholder="Type here" />
                                    </Form.Item>
                                </div> */}

              {/* <div className="edit-profile-form-item">
                                    <span className="edit-profile-caption">Nationality :</span>
                                    <Form.Item
                                    name="Informationnationality"
                                    rules={[{ required: true, message: 'Enter nationality ' }]}
                                    initialValue={patientDetails?.nationality}
                                    >
                                    <Input id='Nationality' defaultValue={patientDetails?.nationality} onChange={(e) => { handleEditInputChanges({ key: "Informationnationality", value: e.target.value}) }} placeholder="Enter Nationality" />
                                    </Form.Item>
                                </div>

                                <div className="edit-profile-form-item">
                                    <span className="edit-profile-caption">National ID :</span>
                                    <Form.Item
                                    name="InformationnationalId"
                                    rules={[{ required: true, message: 'Enter national id  ' }, 
                                    { min: 9,
                                      message: 'National ID must contain 9 character' 
                                    },
                                   
                                    
                                   ]}
                                    initialValue={patientDetails?.nationalId}
                                    >
                                    <Input type={accessCountry==="IN"?'text':'number'} id='Nationality' defaultValue={patientDetails?.nationalId} maxLength={accessCountry==="IN"?12:9} onChange={(e) => { handleEditInputChanges({ key: "InformationnationalId", value: e.target.value}) }} placeholder="Enter National ID" />
                                    </Form.Item>
                                </div> */}

              {/* <div className="edit-profile-form-item">
                                    <span className="edit-profile-caption">Address :</span>
                                    <Input defaultValue={patientDetails?.currenctaddress} placeholder="Type here" />
                                </div> */}
            </div>

            <div className="edit-profile-body">
              <div className="edit-profile-form-item ">
                <span className="edit-profile-caption">
                  Address <label style={{ color: "#ff4d4f" }}>*</label>
                </span>
                <Form.Item
                  name="Informationaddress1"
                  rules={[{ required: true, message: "Enter Address  " }]}
                  initialValue={patientDetails?.address1}
                >
                  <TextArea
                    id="Address1"
                    defaultValue={patientDetails?.address1}
                    onChange={(e) => {
                      handleEditInputChanges({
                        key: "address1",
                        value: e.target.value,
                      });
                    }}
                    rows={5}
                    placeholder="Enter Full Address"
                    onKeyPress={(e) => {
                      const englishRegex = /^[a-zA-Z0-9,-/\s]*$/;
                      if (
                        !englishRegex.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "Delete"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      const pastedData = e.clipboardData.getData("text/plain");
                      const englishRegex = /^[a-zA-Z0-9,-/\s]*$/;
                      if (!englishRegex.test(pastedData)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </div>

              {/* <div className="edit-profile-form-item">
                <span className="edit-profile-caption">
                  Address 2 (Optional):
                </span>
                <Form.Item
                  name="Informationaddress2"
                  //  rules={[{ required: true, message: 'Enter  Address 2  ' }]}
                  initialValue={patientDetails?.address2}
                >
                  <TextArea
                    id="Address2"
                    defaultValue={patientDetails?.address2}
                    onChange={(e) => {
                      handleEditInputChanges({
                        key: "address2",
                        value: e.target.value,
                      });
                    }}
                    rows={5}
                    placeholder="Enter Address 2"
                  />
                </Form.Item>
              </div> */}
              {/* <div className="edit-profile-form-item">
                                    <span className="edit-profile-caption">City :</span>
                                    <Form.Item
                                    name="Informationcity"
                                    rules={[{ required: true, message: 'Enter city' }]}
                                    initialValue={patientDetails?.city}
                                    >
                                    <Input id='City' defaultValue={patientDetails?.city} onChange={(e) => { handleEditInputChanges({ key: "Informationcity", value: e.target.value}) }} placeholder="Enter City" />
                                    </Form.Item>
                                </div>

                                <div className="edit-profile-form-item">
                                    <span className="edit-profile-caption">State :</span>
                                    <Form.Item
                                    name="Informationstate"
                                    rules={[{ required: true, message: 'Enter state' }]}
                                    initialValue={patientDetails?.state}
                                    >
                                    <Input id='State' defaultValue={patientDetails?.state} onChange={(e) => { handleEditInputChanges({ key: "Informationstate", value: e.target.value}) }} placeholder="Enter State" />
                                    </Form.Item>
                                </div>
                                <div className="edit-profile-form-item">
                                    <span className="edit-profile-caption">Country :</span>
                                    <Form.Item
                                    name="Informationcountry"
                                    rules={[{ required: true, message: 'Enter country' }]}
                                    initialValue={patientDetails?.country}
                                    >
                                    <Input  defaultValue={patientDetails?.country} id='Country' onChange={(e) => { handleEditInputChanges({ key: "Informationcountry", value: e.target.value}) }} placeholder="Enter Country" />
                                    </Form.Item>
                                </div> */}

              {/* <div className="edit-profile-form-item">
                                    <span className="edit-profile-caption">PIN Code :</span>
                                    <Form.Item
                                    name="InformationPIN"
                                    rules={[{ required: true, message: 'Enter PIN Code' },
                                    {
                                        max: 7,
                                        message: "Value should be less than 7 character",
                                      }]}
                                    initialValue={patientDetails?.PIN}
                                    >
                                    <Input type="number" maxLength={7} id='PIN Code' defaultValue={patientDetails?.PIN} onChange={(e) => { handleEditInputChanges({ key: "InformationPIN", value: e.target.value}) }} placeholder="Enter PIN Code" />
                                    </Form.Item>
                                </div> */}

              {/* <div className="edit-profile-form-item">
                                    <span className="edit-profile-caption">Landmark (Optional):</span>
                                    <Form.Item
                                    name="Informationlandmark"
                                  
                                    initialValue={patientDetails?.landmark}
                                    >
                                    <Input id='Landmark' defaultValue={patientDetails?.landmark} onChange={(e) => { handleEditInputChanges({ key: "Informationlandmark", value: e.target.value}) }} placeholder="Enter Landmark" />
                                    </Form.Item>
                                </div> */}
            </div>
            <div className="edit-profile-footer">
              <a className="edit-modal-footer-button" onClick={handleEditClose}>
                Close
              </a>
              <button
                type="submit"
                // onClick={ () => setMainNumber(true)}
                className="edit-modal-footer-button edit-modal-footer-button-save"
              >
                Save
              </button>
            </div>
          </Form>
        </div>
      </Modal>
    </>
  );
};

const DataAccordion = ({ isMemberSection }) => {
  let membersAddedHeaders = [
    { name: "Patient ID", key: "patient_id" },
    { name: "Name", key: "member_name" },
    { name: "Date of Birth", key: "member_dob" },
    { name: "Gender", key: "member_gender" },
  ];
  let appointmentHistoryHeaders = [
    { name: "Date", key: "date" },
    { name: "Doctor Name", key: "doctor_name" },
    { name: "Appointment ID", key: "appointment_id" },
    {
      name: "Payment Details",
      key: "payment_details",
      subMenu: [
        { name: "Amount", key: "amount" },
        { name: "Transaction ID", key: "transaction_id" },
      ],
    },
    { name: "Appointment Documents", key: "appointment_documents" },
    { name: "Booked from", key: "booked_from" },
  ];

  let dummyMembersData = [
    {
      patient_id: "P001",
      member_name: "John Smith",
      member_dob: "01 Jan 2023",
      member_gender: "male",
    },
    {
      patient_id: "P002",
      member_name: "Jane Doe",
      member_dob: "01 Jan 2023",
      member_gender: "female",
    },
    {
      patient_id: "P003",
      member_name: "Robert Johnson",
      member_dob: "01 Jan 2023",
      member_gender: "male",
    },
  ];
  let dummyAppointmentData = [
    {
      date: "01 Jan 2023",
      doctor_name: "Dr. John Smith",
      appointment_id: "12345",
      payment_details: {
        amount: "₹100",
        method: "credit card",
        transaction_id: "67890",
      },
      appointment_documents: [
        {
          document_name: "Patient history",
          url: "https://example.com/docs/patient_history.pdf",
        },
        {
          document_name: "Prescription",
          url: "https://example.com/docs/prescription.pdf",
        },
      ],
      booked_from: "Mobile app",
    },
    {
      date: "01 Jan 2023",
      doctor_name: "Dr. Jane Doe",
      appointment_id: "23456",
      payment_details: {
        amount: 150,
        method: "debit card",
        transaction_id: "34567",
      },
      appointment_documents: [
        {
          document_name: "Lab test report",
          url: "https://example.com/docs/lab_test_report.pdf",
        },
        {
          document_name: "X-ray report",
          url: "https://example.com/docs/x_ray_report.pdf",
        },
      ],
      booked_from: "Website",
    },
    {
      date: "2023-03-09",
      doctor_name: "Dr. Michael Johnson",
      appointment_id: "34567",
      payment_details: {
        amount: 200,
        method: "cash",
        transaction_id: null,
      },
      appointment_documents: [
        {
          document_name: "Medical certificate",
          url: "https://example.com/docs/medical_certificate.pdf",
        },
      ],
      booked_from: "Phone call",
    },
  ];

  let getData = () =>
    isMemberSection ? dummyMembersData : dummyAppointmentData;
  let getHeader = () =>
    isMemberSection ? membersAddedHeaders : appointmentHistoryHeaders;

  return (
    <>
      <Accordion className={styles.detailsAcccordion}>
        {getData().map((eachData, dataKey) => {
          return (
            <Accordion.Item key={dataKey} eventKey={dataKey}>
              <Accordion.Header>
                {eachData.member_name || eachData.doctor_name}
              </Accordion.Header>
              <Accordion.Body>
                {getHeader().map((eachHeader, key) => {
                  if (["payment_details"].includes(eachHeader.key)) {
                    //For Payment details................................
                    return (
                      <div key={key} className={styles.member_details_item}>
                        <div key={key} className={styles.member_details_item}>
                          <div className={styles.member_details_item_key}>
                            {eachHeader?.name}
                          </div>
                          <div>:</div>
                          <div className={styles.member_details_item_value}>
                            {eachHeader.subMenu &&
                              eachHeader.subMenu.map(
                                (eachSubMenuHead, subMenuKey) => {
                                  return (
                                    <div key={subMenuKey}>
                                      {eachSubMenuHead?.name} -{" "}
                                      {
                                        eachData[eachHeader?.key][
                                          eachSubMenuHead?.key
                                        ]
                                      }
                                    </div>
                                  );
                                }
                              )}
                          </div>
                        </div>
                      </div>
                    );
                  } else if (
                    ["appointment_documents"].includes(eachHeader.key)
                  ) {
                    //For Documents................................

                    let reports = eachData[eachHeader.key];

                    return (
                      <div key={key} className={styles.member_details_item}>
                        <div key={key} className={styles.member_details_item}>
                          <div className={styles.member_details_item_key}>
                            {eachHeader?.name}
                          </div>
                          <div>:</div>
                          <div className={styles.member_details_item_value}>
                            <ul>
                              {reports &&
                                reports.length > 0 &&
                                reports.map((eachReport, reportKey) => (
                                  <li key={reportKey}>
                                    <Tooltip title={eachReport?.document_name}>
                                      Report - {reportKey + 1}
                                    </Tooltip>
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div key={key} className={styles.member_details_item}>
                        <div className={styles.member_details_item_key}>
                          {eachHeader?.name}
                        </div>
                        <div>:</div>
                        <div className={styles.member_details_item_value}>
                          {eachData[eachHeader?.key]}
                        </div>
                      </div>
                    );
                  }
                })}
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </>
  );
};

const ConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  console.log("testes", isOpen, onClose, onConfirm);
  if (!isOpen) return null;

  return (
    <>
      <Modal footer={false} closeIcon={<></>} header={null} open={isOpen}>
        <div className="modal">
          <div className="modal-content">
            <p>Are you sure you want to reset your password?</p>
            <button onClick={onConfirm}>Yes</button>
            <button onClick={onClose}>No</button>
          </div>
        </div>
      </Modal>
    </>
  );
};
